'use client';
import e__default from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var o, r, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(t);
        for(r = 0; r < p.length; r++)o = p[r], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (n[o] = t[o]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var o, r, n = {}, p = Object.keys(t);
    for(r = 0; r < p.length; r++)o = p[r], e.indexOf(o) >= 0 || (n[o] = t[o]);
    return n;
}
const DropdownOption = renderWithRef('DropdownOption', null, (o, r)=>{
    var { children: n } = o, p = _object_without_properties(o, [
        "children"
    ]);
    return e__default.createElement(RenderComp, {
        root: "option",
        forwardedRef: r,
        props: p
    }, n);
});

export { DropdownOption };
